export const httpResponses = {
  fr: {
    successfull_operation: 'Opération effectué avec succès',
    failed_operation:
      'Une erreur est survenue, veuillez réessayer. Si le problème persiste, vveuillez contacter le support',
    authentification_failed: "Échec d'authentification",
    authentification_success: 'Connexion réussie',
  },
};
